module.exports = __webpack_public_path__ + "img/gift_2.398976bf.png";